import styled from 'styled-components';

import { WHITE, BLACK } from '@/styles/variables.style';

export const Menu = styled.div`
  left: 0;
  opacity: ${({ show }) => (show ? 1 : 0)};
  padding: 0 15px;
  transition: opacity 200ms ease-in-out, visibility 200ms ease-in-out;
  visibility: ${({ show }) => (show ? 'visible' : 'hidden')};
  width: 100vw;

  &.headerMenu {
    position: fixed;
    top: 0;
    height: 100vh;
    background: ${WHITE};
  }

  &.footerMenu {
    position: absolute;
    bottom: 0;
    height: 600px;
    padding: 0 20px;
    background: ${BLACK};
    overflow: hidden;
  }
`;

export const MenuWrapper = styled.div`
  display: flex;
  height: 100%;
  position: relative;
  width: 100%;
`;

export const ButtonContainer = styled.div`
  align-items: center;
  display: flex;
  height: 60px;
  position: absolute;
  right: 15px;
  top: 0;
  z-index: 9999;
`;

export const CloseButton = styled.div`
  background-image: ${({ close }) => `url(${close})`};
  background-size: contain;
  cursor: pointer;
  height: 16px;
  width: 16px;
`;



// WEBPACK FOOTER //
// ./src/components/GlobalMenu/Mobile/MobileMenu.style.js